import React, { useCallback } from "react";
import { useField } from "formik";
import { useCategoriesById } from "@hooks/useCategoriesById";
import { useEntities } from "@hooks/useEntities";
import {
    TransactionRuleConditionFormSchema,
    TransactionRuleActionFormSchema,
    FormRuleActionType,
} from "../constants";
import { EntityFilter } from "../../../../general/EntityFilter/EntityFilter";

interface Props {
    index: number;
}

export const EntityConditionForm: React.FC<Props> = ({ index }) => {
    const categoriesById = useCategoriesById();
    const entities = useEntities();
    const [field, , helpers] = useField<
        TransactionRuleConditionFormSchema["entityValue"]
    >(`conditions.${index}.entityValue`);

    const [actions] = useField<TransactionRuleActionFormSchema[]>("actions");

    const onChange = useCallback(
        (entityIds: number[] | undefined) => {
            const categoryAction = actions.value.find(
                (action) => action.actionType === FormRuleActionType.CATEGORY,
            );

            if (categoryAction?.value?.categoryId) {
                const category =
                    categoriesById[categoryAction.value.categoryId];
                const isPersonalEntitySelected = entityIds?.some(
                    (entityId) =>
                        entities.find((e) => e.id === entityId)?.isPersonal,
                );
                if (category.isBusiness && isPersonalEntitySelected) {
                    categoryAction.value.categoryId = undefined;
                }
            }

            helpers.setValue(entityIds);
        },
        [actions.value, categoriesById, entities, helpers],
    );

    return (
        <EntityFilter
            filters={{ entityIds: field.value ?? [] }}
            onChange={(filters) => onChange(filters.entityIds)}
        />
    );
};
